import React, { useEffect, useState } from 'react';
import './Hero.css';

const HeroHeadline = ({ approvedProjects }) => {

  const [showSecondText, setShowSecondText] = useState(false)

  useEffect(() => {
    if (approvedProjects > 0) {
      const timer = setTimeout(() => setShowSecondText(true), 500);
      return () => clearTimeout(timer);
    }
  }, [approvedProjects]);

  return (
    <h1>
      <span className={`fade-in ${showSecondText ? "visible" : ""}`}>
        Labour has approved {approvedProjects} major projects so&nbsp;far
      </span>
    </h1>
  );
};

export default HeroHeadline;
